module.exports = __webpack_public_path__ + "static/media/BannerDashboard.a41b85b9.png";